var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcIdActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.667c0-2.025 1.642-3.667 3.667-3.667h14.666c2.025 0 3.667 1.642 3.667 3.667v14.666c0 2.025-1.642 3.667-3.667 3.667h-14.666c-2.025 0-3.667-1.642-3.667-3.667v-14.666Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.355 15.419h3.599c2.866 0 4.142 1.719 4.142 4.545c0 2.854-1.309 4.619-4.142 4.619h-3.599v-9.164Zm2.222 1.759v5.646h1.027c1.283 0 2.216-0.544 2.216-2.806c0-1.611-0.497-2.84-2.216-2.84h-1.027Z",
    fill: "#EB2553"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.576 24.583h-2.222v-9.164h2.222v9.164Z",
    fill: "#EB2553"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIdActive);
export default __webpack_public_path__ + "static/media/ic_id_active.523e7b4521539ca32cf812018e7332bc.svg";
export { ForwardRef as ReactComponent };